import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Paper from "@mui/material/Paper";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DevicesIcon from "@mui/icons-material/Devices";
import PreviewIcon from "@mui/icons-material/Preview";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import Tooltip from "@mui/material/Tooltip";
import DoneIcon from "@mui/icons-material/Done";
import BallotOutlinedIcon from "@mui/icons-material/BallotOutlined";
import HouseOutlinedIcon from "@mui/icons-material/HouseOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxStyled from "../common/components/Checkbox";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import types from "../CellStepManagement/duck/types";
import { studiesOperations } from "../Studies/duck/index";
import LoadingSpinner from "../common/components/LoadingSpinner";
import Status from "./components/Status";
import { overviewOperations } from "./duck";
import ModalRoot from "../Modal/ModalContainer";
import { Typography, Button, Divider } from "@mui/material";
import StudySpecificStimsContainer from "../Stims/StudySpecificStimsComponent/StudySpecificStimsContainer";
import EditPanelMenu from "./components/EditPanelMenu";
import StudyTimeline from "./components/StudyTimeline";
import NewLinksTable from "../Links/components/NewLinksTable";
import { LinksOperations } from "../Links/duck/index";
import ConfirmActionModal from "../Modal/components/ConfirmActionModal";
import { userOperations } from "../MyDetails/duck";
import DataService from "../common/services/dataService";
import PhaseColourHelper from "../Dashboard/components/PhaseColourHelper";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const Overview = (props) => {
  const {
    getAudienceOverviewData,
    getOverviewData,
    fetchStudy,
    fetchStudySpecificStims,
    fetchStudyDetails,
    openModal,
    openConfirmationModal,
    confirmationModalOpen,
    closeConfirmationModal,
    modalOpen,
    match: {
      params: { id: studyId },
    },
    panelOverview,
    loading,
    studiesOverview,
    panelLoading,
    overviewLoading,
    homeReducer,
    getLinksData,
    links,
    postEndLiveStudy,
    user,
    getUserData,
    studyActions,
  } = props;
  const payload = { id: studyId };
  const [isLoading, setIsLoading] = useState(true);
  const [isSuperUser, setIsSuperUser] = useState(false);
  const [phaseColour, setPhaseColour] = useState(1);
  const [excludeFromChecks, setExcludeFromChecks] = useState(true);
  const [pauseOverride, setPauseOverride] = useState(true);
  const [resetModalOpen, setResetModalOpen] = useState(false);
  const [resetReasons, setResetReasons] = useState([]);
  const [selectedReasonId, setSelectedReasonId] = useState("");
  const [resetSubmitting, setResetSubmitting] = useState(false);
  const [resetReasonError, setResetReasonError] = useState("");
  const [resetComments, setResetComments] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

const normalizePhaseColour = (value) => {
  if (value === "Green" || value === 1 || value === "1") return 1;
  if (value === "Amber" || value === 2 || value === "2") return 2;
  if (value === "Red" || value === 3 || value === "3") return 3;
  return 1; // default fallback
};

useEffect(() => {
  if (studiesOverview) {
    const normalizedColour = normalizePhaseColour(
      studiesOverview.phase_colour ||
      studiesOverview.phase_colour_id ||
      studiesOverview.phase_id
    );

    setPhaseColour(normalizedColour);

    // Load ExcludeFromChecks from backend
    if (typeof studiesOverview.phase_colour_system_processing_enabled === "boolean") {
      setExcludeFromChecks(studiesOverview.phase_colour_system_processing_enabled);
    }

    // Load PauseOverride from backend OR default to true
    if (typeof studiesOverview.phase_colour_system_paused_override === "boolean") {
      setPauseOverride(studiesOverview.phase_colour_system_paused_override);
    } else {
      setPauseOverride(true); // default only when backend doesn't send anything
    }
  }
}, [studiesOverview]);




  useEffect(() => {
    getAudienceOverviewData(studyId);
    getOverviewData(studyId);
    fetchStudy(payload);
    fetchStudySpecificStims(studyId);
    fetchStudyDetails(studyId);
    getLinksData(studyId);
    getUserData().then(() => {
      const superUser = localStorage.getItem("superUser");
      setIsSuperUser(superUser === "true");
    });

    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleOpenModal = (TYPE, panelId) => {
    const data = {
      type: types.SHOW_MODAL,
      modalType: TYPE,
      modalProps: {
        modalOpen,
        id: studyId,
        type: TYPE,
        panelId,
        panelOverview,
      },
    };
    openModal(studyId, data);
  };

  const handleOpenConfirmationModal = (TYPE, panel) => {
    const data = {
      type: types.SHOW_MODAL,
      modalType: TYPE,
      modalProps: {
        id: studyId,
        type: TYPE,
        panel,
        confirmationModalOpen,
        closeConfirmationModal,
      },
    };
    openConfirmationModal(studyId, data);
  };

  const submitSubscribeToStudy = async () => {
    await DataService.postAssignToAction(studyId);
    fetchStudyDetails(studyId);
  };

  if (loading || panelLoading || overviewLoading || isLoading) {
    return <LoadingSpinner />;
  }

  const startDate = studiesOverview.data_collection_start
    ? studiesOverview.data_collection_start
        .split("T")[0]
        .split("-")
        .reverse()
        .join()
        .replaceAll(",", "/")
    : "";
  const endDate = studiesOverview.data_collection_end
    ? studiesOverview.data_collection_end
        .split("T")[0]
        .split("-")
        .reverse()
        .join()
        .replaceAll(",", "/")
    : "pending";
  const date = `${startDate} - ${endDate}`;
  
// const phaseColour = Number(studiesOverview.phase_colour) || 1;

const formatPerson = (user) => {
  if (!user) return "—";

  const first = (user.first_name || "").trim();
  const last = (user.last_name || "").trim();
  const full = `${first} ${last}`.trim();

  // Prefer full name, then username, then email, else dash
  return full || (user.username || "").trim() || (user.email || "").trim() || "—";
};

const safeEmail = (user) => (user?.email ? user.email : "");

const fetchResetReasons = async () => {
  try {
    const response = await DataService.getResetToGreenReasons();
    console.log("reset reasons response:", response);
    console.log("reset reasons response.data:", response?.data);
    setResetReasons(response?.data || []);
  } catch (err) {
    console.error("Failed to fetch reset-to-green reasons", err);
    setResetReasons([]);
  }
};

const handleSubmitResetToGreen = async () => {
  let hasError = false;

  if (!selectedReasonId) {
    setResetReasonError("Please select a reason");
    hasError = true;
  }

  if (hasError) return;

  try {
    setResetSubmitting(true);

    const response = await DataService.setStudyPhaseColour(studyId, {
      colour_command: "reset-to-green",
      reason_id: Number(selectedReasonId),
      comments: resetComments.trim(),
    });

    if (response?.data?.success === false) {
      throw new Error(
        response?.data?.message ||
          response?.data?.error ||
          "Failed to reset study to green."
      );
    }

    setPhaseColour(1);
    setResetModalOpen(false);
    setSelectedReasonId("");
    setResetComments("");
    setResetReasonError("");

    setSnackbarOpen(true);
    setSnackbarMessage("Study reset to green successfully.");
    setSnackbarSeverity("success");

    await Promise.all([
      fetchStudyDetails(studyId),
      getOverviewData(studyId),
      getAudienceOverviewData(studyId),
    ]);
  } catch (err) {
    const backendMessage =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.response?.data?.detail ||
      err?.message ||
      "Failed to reset study to green. Please try again later.";

    setSnackbarOpen(true);
    setSnackbarMessage(backendMessage);
    setSnackbarSeverity("error");
  } finally {
    setResetSubmitting(false);
  }
};



  return (
    <div>
      <Paper
        style={{
          borderRadius: 16,
          padding: 16,
          minWidth: 1300,
          minHeight: "90vh",
        }}
      >
        <Typography
          component={"span"}
          style={{ textAlign: "center", paddingTop: "12px" }}
          variant="h3"
        >
          {studiesOverview.study_name} Overview
        </Typography>
        <div className="overview__container">
          <div
            style={{
              display: "grid",
              gap: 32,
              padding: "16px 16px",
              gridTemplateColumns: "3fr 5fr 3fr",
            }}
          >
            <Paper
              variant="outlined"
              style={{ borderRadius: 16, padding: 16, height: "fit-content" }}
            >
              <Typography
                component={"span"}
                style={{ paddingBottom: 16 }}
                variant="h6"
              >
                Study details
              </Typography>
              {studiesOverview.brief ? (
                <Typography
                  style={{ paddingBottom: 16, color: "rgb(99, 115, 129)" }}
                  variant="body2"
                >
                  {studiesOverview.brief}
                </Typography>
              ) : (
                ""
              )}
              <Typography
                component={"span"}
                style={{
                  paddingBottom: 16,
                  color: "rgb(99, 115, 129)",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
                variant="body2"
              >
                <LocationOnIcon style={{ marginRight: 4 }} /> Language:{" "}
                <b> {studiesOverview.language}</b>
              </Typography>
              <Typography
                component={"span"}
                style={{
                  paddingBottom: 16,
                  color: "rgb(99, 115, 129)",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
                variant="body2"
              >
                <DateRangeIcon style={{ marginRight: 4 }} />
                Data collection: <b>{date}</b>
              </Typography>
              <Typography
                component={"span"}
                style={{
                  paddingBottom: 16,
                  color: "rgb(99, 115, 129)",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
                variant="body2"
              >
                <DevicesIcon style={{ marginRight: 4 }} />
                Environment: <b>{studiesOverview.environment}</b>
              </Typography>
              <Typography
                component={"span"}
                style={{
                  paddingBottom: 16,
                  color: "rgb(99, 115, 129)",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
                variant="body2"
              >
                <PreviewIcon style={{ marginRight: 4 }} />
                Media: <b>{studiesOverview.media}</b>
              </Typography>

{/*owner */}
<>
  <Typography
    component={"span"}
    style={{
      paddingBottom: 4,
      color: "rgb(99, 115, 129)",
      display: "flex",
      alignItems: "center",
      gap: 4,
    }}
    variant="body2"
  >
    <PersonOutlineIcon style={{ marginRight: 4 }} />
    Owner: <b>{formatPerson(studiesOverview.owner)}</b>
  </Typography>

  <Typography
    component={"span"}
    style={{
      paddingBottom: 16,
      color: "rgb(99, 115, 129)",
      display: "block",
      paddingLeft: 28, // lines up under text after icon
    }}
    variant="body2"
  >
    {safeEmail(studiesOverview.owner) || "—"}
  </Typography>
</>

{/* consultant owner */}
<>
  <Typography
    component={"span"}
    style={{
      paddingBottom: 4,
      color: "rgb(99, 115, 129)",
      display: "flex",
      alignItems: "center",
      gap: 4,
    }}
    variant="body2"
  >
    <PersonOutlineIcon style={{ marginRight: 4 }} />
    Consultant owner: <b>{formatPerson(studiesOverview.consultant_user)}</b>
  </Typography>

  <Typography
    component={"span"}
    style={{
      paddingBottom: 16,
      color: "rgb(99, 115, 129)",
      display: "block",
      paddingLeft: 28,
    }}
    variant="body2"
  >
    {safeEmail(studiesOverview.consultant_user) || "—"}
  </Typography>
</>

              <div style={{ width: "100%", display: "flex" }}>
                <Button
                  style={{
                    padding: "3px 9px",
                    border: "unset",
                    borderRadius: 8,
                    textTransform: "capitalize",
                    margin: "auto",
                  }}
                  component={Link}
                  to={`/my_studies/overview/${studyId}/edit-details`}
                  variant="outlined"
                  endIcon={<ChevronRightIcon />}
                >
                  Edit Study Details
                </Button>
              </div>
              <Divider style={{ margin: "16px 0px" }} />
              <Typography
                component={"span"}
                style={{ paddingBottom: 16 }}
                variant="h6"
              >
                Study structure
              </Typography>
              <Typography
                component={"span"}
                style={{
                  paddingBottom: 16,
                  color: "rgb(99, 115, 129)",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
                variant="body2"
              >
                <HouseOutlinedIcon style={{ marginRight: 4 }} />
                Number of cells:{" "}
                <b>{studiesOverview.cell_step_stim_overview.cell_count}</b>
              </Typography>
              <Typography
                component={"span"}
                style={{
                  paddingBottom: 16,
                  color: "rgb(99, 115, 129)",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
                variant="body2"
              >
                <ImageOutlinedIcon style={{ marginRight: 4 }} />
                Number of stims:{" "}
                <b>{studiesOverview.cell_step_stim_overview.stim_count}</b>
              </Typography>
              <div style={{ width: "100%", display: "flex" }}>
                <Button
                  style={{
                    padding: "3px 9px",
                    border: "unset",
                    borderRadius: 8,
                    textTransform: "capitalize",
                    margin: "auto",
                  }}
                  component={Link}
                  to={`/my_studies/overview/${studyId}/cell_step_management`}
                  variant="outlined"
                  endIcon={<ChevronRightIcon />}
                >
                  Edit Study Structure
                </Button>
              </div>
              <Divider style={{ margin: "16px 0px" }} />
              <Typography
                component={"span"}
                style={{ paddingBottom: 16 }}
                variant="h6"
              >
                Survey details
              </Typography>
              <Typography
                component={"span"}
                style={{
                  paddingBottom: 16,
                  color: "rgb(99, 115, 129)",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
                variant="body2"
              >
                <BallotOutlinedIcon style={{ marginRight: 4 }} />
                Demographic survey{" "}
                {studiesOverview.survey_overview.has_survey ? (
                  <DoneIcon style={{ fontSize: 22 }} color="success" />
                ) : (
                  <CloseIcon style={{ fontSize: 22 }} color="error" />
                )}{" "}
              </Typography>
              <Typography
                component={"span"}
                style={{
                  paddingBottom: 16,
                  color: "rgb(99, 115, 129)",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
                variant="body2"
              >
                <BallotOutlinedIcon style={{ marginRight: 4 }} />
                Recall survey{" "}
                {studiesOverview.survey_overview.has_demographics ? (
                  <DoneIcon style={{ fontSize: 22 }} color="success" />
                ) : (
                  <CloseIcon style={{ fontSize: 22 }} color="error" />
                )}
              </Typography>
              <Typography
                component={"span"}
                style={{
                  paddingBottom: 16,
                  color: "rgb(99, 115, 129)",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
                variant="body2"
              >
                <BallotOutlinedIcon style={{ marginRight: 4 }} />
                Number of questions:{" "}
                <b>{studiesOverview.survey_overview.num_questions}</b>
              </Typography>
              <Tooltip title="This button is permanently disabled">
                <div style={{ width: "100%", display: "flex" }}>
                  <Button
                    style={{
                      padding: "3px 9px",
                      border: "unset",
                      borderRadius: 8,
                      textTransform: "capitalize",
                      margin: "auto",
                    }}
                    component={Link}
                    disabled={true}
                    to={`/my_studies/overview/${studyId}/survey-questions`}
                    variant="outlined"
                    endIcon={<ChevronRightIcon />}
                  >
                    Edit Survey details
                  </Button>
                </div>
              </Tooltip>
              <Divider style={{ margin: "16px 0px" }} />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <Typography component={"span"} variant="h6">
                    Panels
                  </Typography>
                  <Typography
                  
                    style={{ paddingBottom: 16 }}
                    variant="body2"
                  >
                    {studiesOverview.audience_overview.participants_requested}{" "}
                    participants requested
                  </Typography>
                </div>
                <Tooltip title="Create panel">
                  <IconButton
                    onClick={() => handleOpenModal("CREATE_AUDIENCE")}
                    color="primary"
                    size="large"
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {studiesOverview.audience_overview.panels.map((item, index) => (
                <div key={index}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <Typography component={"span"} variant="subtitle2">
                        {index + 1} {item.name}
                      </Typography>
                    </div>
                    <EditPanelMenu
                      key={index}
                      onEditClick={() =>
                        handleOpenModal("EDIT_AUDIENCE", item.id)
                      }
                      onDeleteClick={() =>
                        handleOpenConfirmationModal("DELETE_CONFIRMATION", item)
                      }
                    />
                  </div>
                </div>
              ))}
            </Paper>
            <div>
<Paper
  variant="outlined"
  style={{
    borderRadius: 16,
    padding: 16,
    marginBottom: 24,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    background:
      phaseColour === 1
        ? "rgb(200, 250, 205)" 
        : phaseColour === 2
        ? "#faab89ff"
        : phaseColour === 3
        ? "#ff7474ff" 
        : "#f2f2f2", 
       transition: "background-color 0.4s ease-in-out", //
  }}
>
  <div style={{ padding: "8px 16px 0px" }}>
    <Typography variant="h6">
      {phaseColour === 3
        ? "ATTENTION REQUIRED!"
        : phaseColour === 2
        ? "WARNING!"
        : "Congratulations"}{" "}
      {homeReducer.first_name || ""}
    </Typography>
  </div>

  <div style={{ padding: "0px 16px 16px" }}>
    <Typography variant="subtitle1" style={{ color: "rgb(99, 115, 129)" }}>
      {phaseColour === 3
        ? "This study has encountered a critical error. Please review below."
        : phaseColour === 2
        ? "This study requires attention. Some warnings have been detected."
        : "Your results are now ready for inspection."}
    </Typography>
  </div>

  <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "12px",
      padding: "0 16px 8px",
    }}
  >
    {(phaseColour === 3 || phaseColour === 2) && (
      <Button

    onClick={async () => {
      setResetModalOpen(true);
      setSelectedReasonId("");
      setResetComments("");
      setResetReasonError("");

      if (!resetReasons.length) {
        await fetchResetReasons();
      }
    }}


        style={{
          backgroundColor: "rgb(0, 171, 85)", 
          color: "#fff",
          textTransform: "capitalize",
          borderRadius: 4,
          padding: "6px 16px",
        }}
        variant="contained"
      >
        Reset to Green
      </Button>
    )}

    <Button
      component={Link}
      to={`/my_studies/overview/${studyId}/reports-new`}
      variant="contained"
      style={{
        background:
          phaseColour === 3 || phaseColour === 2
            ? "#b0bec5" 
            : "rgb(0, 171, 85)", 
        color: "#fff",
        textTransform: "capitalize",
        borderRadius: 4,
        padding: "6px 16px",
      }}
    >
      View results
    </Button>
  </div>
</Paper>


              <Paper
                variant="outlined"
                style={{ borderRadius: 16, padding: 16 }}
              >
                <Typography
                  component={"span"}
                  style={{ padding: "0px 8px 16px" }}
                  variant="h6"
                >
                  Panel links
                </Typography>
                <NewLinksTable data={links} />
              </Paper>
            </div>
            <div>
              <Paper
                variant="outlined"
                style={{
                  borderRadius: 16,
                  padding: 16,
                  marginBottom: 24,
                  minWidth: 330,
                }}
              >
                <StudyTimeline
                  phaseId={studiesOverview.phase_id}
                  postEndLiveStudy={postEndLiveStudy}
                  studyId={studyId}
                />
              </Paper>
<Paper
  variant="outlined"
  style={{ borderRadius: 16, padding: 16, marginBottom: 24 }}
>
  <Typography
    component={"span"}
    style={{
      display: "flex",
      justifyContent: "space-between",
      padding: "0px 8px 0px",
    }}
    variant="h6"
  >
    Actions
    <ConfirmActionModal
      openButtonText={"Subscribe Me"}
      action={submitSubscribeToStudy}
      className="SubscribeToStudy"
      title="Subscribe to this study?"
      mainText={
        <>
          Add <span style={{ fontStyle: "italic" }}>{user.email}</span> to
          receive updates on{" "}
          <span style={{ fontStyle: "italic" }}>{studiesOverview.study_name}</span>{" "}
          study
        </>
      }
    />
  </Typography>

  {/* Existing action assignments */}
  {studyActions?.length
    ? studyActions.map(({ name, type, assignments }) => (
        <div key={type}>
          <Typography
            component={"span"}
            style={{
              paddingTop: 16,
              color: "rgb(99, 115, 129)",
              display: "flex",
              alignItems: "center",
              gap: 4,
              padding: "0px 8px 0px",
            }}
          >
            {name}:
          </Typography>
          {assignments.map(({ email }) => (
            <Typography
              component={"span"}
              style={{
                color: "rgb(99, 115, 129)",
                display: "flex",
                alignItems: "center",
                gap: 4,
                padding: "0px 8px 0px",
              }}
              variant="body2"
              key={email}
            >
              <li>{email}</li>
            </Typography>
          ))}
        </div>
      ))
    : null}

  
{Number(studiesOverview.phase_id) === 4 && (
  <>
    {/* Include Quality checks */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 20,
    padding: "0px 8px",
  }}
>
<FormControlLabel
  control={
    <Switch
      checked={excludeFromChecks}
      onChange={async () => {
        const newValue = !excludeFromChecks;
        setExcludeFromChecks(newValue);

        try {
          await DataService.setStudyPhaseColour(
            studyId,
            newValue ? "toggle-enabled-true" : "toggle-enabled-false"
          );

          await Promise.all([
            fetchStudyDetails(studyId),
            getOverviewData(studyId),
            getAudienceOverviewData(studyId),
          ]);
        } catch (err) {
          console.error("Failed to update system processing flag", err);
        }
      }}
      color="primary"
    />
  }
  label="Include Quality checks"
  sx={{ ml: 1 }}
/>
</div>


    {/* NEW checkbox — Override System Pause */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 12,
    padding: "0px 8px",
  }}
>
<FormControlLabel
  control={
    <Switch
      checked={pauseOverride}
      onChange={async () => {
        const newValue = !pauseOverride;
        setPauseOverride(newValue);

        try {
          await DataService.setStudyPhaseColour(
            studyId,
            newValue ? "toggle-pause-override-true" : "toggle-pause-override-false"
          );

          await Promise.all([
            fetchStudyDetails(studyId),
            getOverviewData(studyId),
            getAudienceOverviewData(studyId),
          ]);
        } catch (err) {
          console.error("Failed to update pause override flag", err);
        }
      }}
      color="primary"
    />
  }
  label="Override System Pause"
  sx={{ ml: 1 }}
/>
</div>

  </>
)}


</Paper>

              <Paper
                variant="outlined"
                style={{ borderRadius: 16, padding: 16, marginBottom: 24 }}
              >
                <Typography
                  component={"span"}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0px 8px 0px",
                  }}
                  variant="h6"
                >
                  Study Run Through
                  {isSuperUser ? (
                    <ConfirmActionModal
                      openButtonText={"Automate"}
                      action={() => DataService.handleAutomateStudy(studyId)}
                      className="StudyRunThrough"
                      title="Automate Study Run Through"
                      mainText={
                        "Confirm the trigger of the study run through test?"
                      }
                    />
                  ) : (
                    <Tooltip title="Only Admin can automate this study">
                      <span>
                        <Button
                          variant="contained"
                          disabled
                          style={{
                            backgroundColor: "#e0e0e0",
                            color: "#9e9e9e",
                            cursor: "not-allowed",
                          }}
                        >
                          Automate
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                </Typography>

                <Typography
                  component={"span"}
                  style={{
                    color: "rgb(99, 115, 129)",
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    padding: "0px 8px 0px",
                  }}
                  variant="body2"
                  // key={email}
                >
                  {/* <li>{email}</li> */}
                  <p>Triggers the ad-hoc run (with users email)</p>
                </Typography>
              </Paper>
              <Paper
  variant="outlined"
  style={{ borderRadius: 16, padding: 16, marginBottom: 24 }}
>
  <Typography
    component={"span"}
    style={{ padding: "0px 8px 0px" }}
    variant="h6"
  >
    Your stims
  </Typography>

  <Typography
    component={"span"}
    style={{
      padding: "0px 8px",
      color: "rgb(99, 115, 129)",
    }}
    variant="caption"
  >
    You have {studiesOverview.cell_step_stim_overview.stim_count} stims
  </Typography>

  <div style={{ width: "100%", display: "flex", marginTop: 16 }}>
    <Button
      component={Link}
      to={`/my_studies/overview/${studyId}/study-specific-stims`}
      variant="outlined"
      endIcon={<ChevronRightIcon />}
      style={{
        padding: "3px 9px",
        borderRadius: 8,
        textTransform: "capitalize",
        margin: "auto",
      }}
    >
      View study stims
    </Button>
  </div>
</Paper>

            </div>
          </div>
          <div className="overview__mini-card-container">
            <Status studyData={studiesOverview} />
          </div>
        </div>
      </Paper>

  <Dialog
  open={resetModalOpen}
  onClose={() => !resetSubmitting && setResetModalOpen(false)}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>Reset to Green</DialogTitle>

  <DialogContent>
  <TextField
    select
    fullWidth
    label="Reason *"
    value={selectedReasonId}
    onChange={(e) => {
      setSelectedReasonId(e.target.value);
      setResetReasonError("");
    }}
    margin="normal"
    error={!!resetReasonError}
    helperText={resetReasonError ? "Required" : " "}
    FormHelperTextProps={{
      sx: {
        minHeight: "20px",
        lineHeight: "1.2em",
      },
    }}
  >
    {resetReasons.map((reason) => (
      <MenuItem key={reason.id} value={reason.id}>
        {reason.description}
      </MenuItem>
    ))}
  </TextField>

  <TextField
    fullWidth
    multiline
    minRows={4}
    label="Additional comments (optional)"
    value={resetComments}
    onChange={(e) => {
      setResetComments(e.target.value);
    }}
    margin="normal"
  />
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() => {
        setResetModalOpen(false);
        setSelectedReasonId("");
        setResetComments("");
        setResetReasonError("");
      }}
      disabled={resetSubmitting}
    >
      Cancel
    </Button>
    <Button
      onClick={handleSubmitResetToGreen}
      variant="contained"
      disabled={resetSubmitting}
    >
      Confirm
    </Button>
  </DialogActions>
</Dialog>


<Snackbar
  open={snackbarOpen}
  autoHideDuration={20000}
  onClose={handleSnackbarClose}
  anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
>
  <Alert
    onClose={handleSnackbarClose}
    severity={snackbarSeverity}
    variant="outlined"
    action={
      <Button color="inherit" size="small" onClick={handleSnackbarClose}>
        OK
      </Button>
    }
  >
    {snackbarMessage}
  </Alert>
</Snackbar>

      <ModalRoot />
    </div>
  );
};

Overview.propTypes = {
  match: propTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    studiesOverview: state.isolationData.studiesOverview,
    loading: state.isolationData.studiesOverviewLoading,
    modalOpen: state.overview.modalOpen,
    panelOverview: state.overview.panelOverview,
    confirmationModalOpen: state.overview.confirmationModalOpen,
    panelLoading: state.isolationData.panelLoading,
    overviewLoading: state.overview.overviewLoading,
    filesModalOpen: state.overview.filesModalOpen,
    homeReducer: state.homeReducer,
    links: state.links.links,
    linksLoading: state.links.linksLoading,
    user: state.userData.userData,
    studyDetails: state.editStudyDetails.studyDetails,
    studyActions: state.overview.studyActions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchStudy: (study) => dispatch(studiesOperations.fetchStudy(study)),
    getAudienceOverviewData: (id) =>
      dispatch(overviewOperations.getAudienceOverviewData(id)),
    getOverviewData: (id) => dispatch(overviewOperations.getOverviewData(id)),
    openModal: (id, data) => dispatch(overviewOperations.openModal(id, data)),
    openConfirmationModal: (id, data) =>
      dispatch(overviewOperations.openConfirmationModal(id, data)),
    closeConfirmationModal: (id, data) =>
      dispatch(overviewOperations.closeConfirmationModal(id, data)),
    fetchStudySpecificStims: (id) =>
      dispatch(studiesOperations.fetchStudySpecificStims(id)),
    fetchStudyDetails: (id) =>
      dispatch(overviewOperations.fetchStudyDetails(id)),
    getLinksData: (data) => dispatch(LinksOperations.getLinksData(data)),
    postEndLiveStudy: (id) => dispatch(studiesOperations.postEndLiveStudy(id)),
    getUserData: () => dispatch(userOperations.getUserData()),
  };
};

Overview.propTypes = {
  getAudienceOverviewData: propTypes.func,
  getOverviewData: propTypes.func,
  fetchStudy: propTypes.func,
  fetchStudySpecificStims: propTypes.func,
  fetchStudyDetails: propTypes.func,
  openModal: propTypes.func,
  openConfirmationModal: propTypes.func,
  confirmationModalOpen: propTypes.bool,
  closeConfirmationModal: propTypes.func,
  modalOpen: propTypes.bool,
  match: propTypes.object,
  panelOverview: propTypes.object,
  loading: propTypes.bool,
  studiesOverview: propTypes.object,
  isolationData: propTypes.object,
  panelLoading: propTypes.bool,
  overviewLoading: propTypes.bool,
  homeReducer: propTypes.object,
  getLinksData: propTypes.func,
  links: propTypes.object,
  postEndLiveStudy: propTypes.func,
  postAssignToAction: propTypes.func,
  user: propTypes.object,
  getUserData: propTypes.func,
  studyActions: propTypes.array,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Overview)
);